import React, { Component } from "react";
import Menu from "../Menu";
import Header from "../Header";
import Footer from "../Footer";
import { Select } from "antd";
const { Option } = Select;

class ChangeUsersStore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: "Change Users Store",
            States: [
                {
                    Label: "Karnataka",
                    Value: 1,
                },
                {
                    Label: "Tamil Nadu",
                    Value: 2,
                },
                {
                    Label: "Telangana",
                    Value: 3,
                },
            ],
            EmployeeName: [
                {
                    Label: "Venu",
                    Value: 1,
                },
                {
                    Label: "Hanuma",
                    Value: 2,
                },
                {
                    Label: "Chinna",
                    Value: 3,
                },
            ],
        };
    }

    render() {
        return (
            <div className="wrapper">
                <Header title={this.state.title} />
                <Menu />
                <div className="content-wrapper">
                    <section className="content">
                        <div className="m-panel mt-10">
                            <div className="m-panel__body p10">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInput">Employee name*</label>
                                            <Select
                                                className="form-control"
                                                required
                                                showSearch
                                                onChange={this._doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {" "}
                                                {this.state.EmployeeName.map((item) => (
                                                    <Option value={item.Value}>{item.Label}</Option>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInput">Store*</label>
                                            <Select
                                                className="form-control"
                                                required
                                                showSearch
                                                onChange={this._doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {" "}
                                                {this.state.States.map((item) => (
                                                    <Option value={item.Value}>{item.Label}</Option>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <div className="m-page__button top-space">
                                    <button
                                        type="button"
                                        onClick={this._doNavToVendors}
                                        className="btn muted-button  deca-btn-orange"
                                    >
                                        Back
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary deca-btn-yellow"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        );
    }
}

export default ChangeUsersStore;
